<div class="button-groups">
    <button (click)="theme='dark'" nz-button nzType="default">Dark</button>
    <button (click)="theme='macarons'" nz-button nzType="default">Macarons</button>
    <button (click)="theme=coolTheme" nz-button nzType="default">Cool</button>
</div>
<div echarts [options]="options" [theme]="theme"></div>